/**
 * App wiring: shared UnifiedTokenService from @vaiu/memoney + this app’s platformApi.
 */
import { platformApi } from './platformApi';
import { getUnifiedTokenService, type UnifiedTokenPlatformApi } from '@vaiu/memoney';

const platformAdapter: UnifiedTokenPlatformApi = {
  get: (endpoint, options) => platformApi.get(endpoint, options as any),
  post: (endpoint, data, options) => platformApi.post(endpoint, data, options as any),
  put: (endpoint, data, options) => platformApi.put(endpoint, data, options as any),
  delete: (endpoint, options) => platformApi.delete(endpoint, options as any),
  getWebSocketUrl: () => platformApi.getWebSocketUrl(),
};

export const unifiedTokenService = getUnifiedTokenService(platformAdapter);

export { UnifiedTokenService, type UnifiedTokenPlatformApi } from '@vaiu/memoney';
